import React from 'react';
import { IconCheck, IconInfo } from '../common/Icons';
import { useI18n } from '../../services/i18n';
import { fmtDate, fmtTime, money, until } from '../../services/api';

export default function OrderConfirm({
  order,
  balance,
  onNavigate,
  onToggleReminder
}) {
  const { t, lang } = useI18n();

  if (!order) return null;

  const start = new Date(order.start);
  const end = new Date(start.getTime() + (order.hours || 1) * 3600e3);
  const remindAt = new Date(start.getTime() - 30 * 60e3);
  const onlineAt = new Date(start.getTime() - 15 * 60e3);

  return (
    <main className="screen screen--plain" style={{ paddingTop: '40px' }} data-testid="screen-confirm">
      <div className="success">
        <div className="success__icon">
          <IconCheck />
        </div>
        <h1>{t('confirm_title')}</h1>
        <p className="muted" style={{ margin: 0 }}>
          {t('starts_in')} {until(start - Date.now(), lang)}
        </p>
      </div>

      <div className="list">
        <div className="list__row">
          <span className="muted">{t('summary_model')}</span>
          <b>{order.model}</b>
        </div>
        <div className="list__row">
          <span className="muted">{t('summary_date')}</span>
          <b>{fmtDate(order.start, lang)}</b>
        </div>
        <div className="list__row">
          <span className="muted">{t('summary_time')}</span>
          <b>{fmtTime(start)} – {fmtTime(end)} · {order.hours} {t('hours_unit')}</b>
        </div>
        <div className="list__row">
          <span className="muted">{t('summary_charged')}</span>
          <b>{money(order.cost)}</b>
        </div>
        <div className="list__row">
          <span className="muted">{t('summary_balance')}</span>
          <b>{money(balance)}</b>
        </div>
      </div>

      <button
        className="toggle-row"
        onClick={onToggleReminder}
        aria-pressed={order.remind}
        data-testid="toggle-remind"
      >
        <span className="col" style={{ gap: '2px' }}>
          <b>{t('remind_telegram')}</b>
          <span className="small muted">{t('remind_telegram_sub', { time: fmtTime(remindAt) })}</span>
        </span>
        <span className={`switch ${order.remind ? 'is-on' : ''}`} />
      </button>

      <div className="note" style={{ background: 'var(--bg-bar)' }}>
        <IconInfo />
        <span>
          {t('online_note_prefix')} <b style={{ color: 'var(--text)' }}>{fmtTime(onlineAt)}</b>. {t('confirm_online_note', { time: fmtTime(onlineAt) }).replace(/^.*?\.\s*/, '')}
        </span>
      </div>

      <div style={{ flex: 1 }} />

      <div className="col">
        <button
          className="btn btn--primary"
          onClick={() => onNavigate('orders')}
          data-testid="btn-to-orders"
        >
          {t('btn_my_orders')}
        </button>
        <button
          className="btn btn--secondary"
          onClick={() => onNavigate('order')}
          data-testid="btn-another-order"
        >
          {t('btn_another_order')}
        </button>
      </div>
    </main>
  );
}
